import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { environment } from 'environments/environment';
import { GuiasService } from '../services/guias/guias.service';


//select Tipo Operacion NOTA DEBITO
@Component({
  selector: 'app-select-tipoOperacionND',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Tipo de Operacion</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoOperacionNDElement" [required] = "require">
               <div *ngIf="view">
                 <mat-option value=0>
                    Todos
                  </mat-option>
                </div>
                  <mat-option *ngFor="let tipoOperacionND of TipoOperacionND" [value]="tipoOperacionND.idGuia" >
                   {{tipoOperacionND.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoOperacionNDComponent implements OnInit {

  @Output() tipoOperacionND : EventEmitter<string> = new EventEmitter();
  @Input() tipoOperacionNDElement : string;
  @Input() view : boolean;
  @Input() require : boolean;
  @Input() modelSelect : string;
  @Input() disable : boolean;
  TipoOperacionND:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoOperacionND.subscribe(
      response => {
        this.TipoOperacionND= response;   
      });
  }

  changeClient(value) {
    this.tipoOperacionND.emit(value);
}

}


//select Moneda
@Component({
  selector: 'app-select-moneda',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Moneda</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="monedaElement" (filtroMoneda)="filtroMoneda" [disabled]="disable" [required] = "require">
               <div *ngIf="view">
                 <mat-option value=''>
                    Todos
                  </mat-option>
                </div>
                  <mat-option *ngFor="let moneda of TipoMoneda" [value]="moneda.idGuia" >
                   {{moneda.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectMonedaComponent implements OnInit {

  @Output() tipoMoneda : EventEmitter<string> = new EventEmitter();
  @Input() filtroMoneda:string;
  @Input() monedaElement : string;
  @Input() disable : boolean;
  @Input() modelSelect : string;
  @Input() view : boolean;
  @Input() require : boolean;
  TipoMoneda:any = [];

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoMoneda.subscribe(
      response => {
        this.TipoMoneda= response;
        if (this.filtroMoneda && this.TipoMoneda ) {
          this.TipoMoneda =  this.TipoMoneda.filter(
            state => state.Codigo != this.filtroMoneda
          );
        }   
      });
  }

  changeClient(value) {
    this.tipoMoneda.emit(value);
}

}

//select Banco

@Component({
  selector: 'app-select-banco',
  template: `<mat-form-field><mat-label>Banco</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="bancoElement" [required] = "require">
               <div *ngIf=view>
                  <mat-option value=0>
                    Todos
                  </mat-option>
                </div>
                  <mat-option *ngFor="let banco of TipoBanco" [value]="banco.idGuia" >
                   {{banco.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectBancoComponent implements OnInit {

  @Output() banco : EventEmitter<string> = new EventEmitter();
  @Input() bancoElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  TipoBanco:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoBanco.subscribe(
      response => {
        this.TipoBanco= response;   
      });
  }

  changeClient(value) {
    this.banco.emit(value);
}
}

//select TipoPago

@Component({
  selector: 'app-select-tipoPago',
  template: `<mat-form-field><mat-label>Tipo de pago</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)">
                <div *ngIf="view">
                  <mat-option value=''>
                    Todos
                  </mat-option>
                </div>    
                  <mat-option *ngFor="let tipoPago of TipoPago" [value]="tipoPago.idGuia" >
                   {{tipoPago.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoPagoComponent implements OnInit {

  @Output() tipoPago : EventEmitter<string> = new EventEmitter();
  @Input() view : boolean;
  TipoPago:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoPago.subscribe(
      response => {
        this.TipoPago= response;   
      });
  }

  changeClient(value) {
    
    this.tipoPago.emit(value);
}
}

//select TipoContacto

@Component({
  selector: 'app-select-tipoContacto',
  template: `<mat-form-field><mat-label>Tipo de contacto</mat-label>
              <mat-select  (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoContactoElement">
                  <mat-option *ngFor="let tipoContacto of TipoContacto" [value]="tipoContacto.idGuia" >
                   {{tipoContacto.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoContactoComponent implements OnInit {

  @Input() tipoContactoElement:string ;
  
  @Output() tipoContacto : EventEmitter<string> = new EventEmitter();
  TipoContacto:any;
  

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoContacto.subscribe(
      response => {
        this.TipoContacto = response;   
      });
  }

  changeClient(value) {
    
    this.tipoContacto.emit(value);
}
}

//select TipoDocumento

@Component({
  selector: 'app-select-tipoDocumento',
  template: `<mat-form-field><mat-label>Tipo de documento</mat-label>
              <mat-select  (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoDocumentoElement" [disabled]="disable" required>
                  <mat-option *ngFor="let tipoDocumento of TipoDocumento" [value]="tipoDocumento.idGuia" >
                   {{tipoDocumento.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoDocumentoComponent implements OnInit {

  @Input() tipoDocumentoElement:string;
  @Input() disable:boolean ;
  @Output() tipoDocumento : EventEmitter<string> = new EventEmitter();
  TipoDocumento:any;
  enable:boolean;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoDocumento.subscribe(
      response => {
         this.TipoDocumento = response;
      });
  }

  changeClient(value) {
    
    this.tipoDocumento.emit(value);
}
}

//select IgvExonerado

@Component({
  selector: 'app-select-igvExonerado',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Agente Retención</mat-label>
              <mat-select  (selectionChange)="changeClient($event.value)" [(ngModel)]="igvExoneradoElement" [disabled]="disable" required>
                  <mat-option *ngFor="let igvExonerado of IgvExonerado" [value]="igvExonerado.idGuia" >
                   {{igvExonerado.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectIgvExoneradoComponent implements OnInit {

  @Input() igvExoneradoElement:string;
  @Input() disable:boolean ;
  @Input() modelSelect : string;
  @Output() igvExonerado : EventEmitter<string> = new EventEmitter();
  IgvExonerado:any;
  enable:boolean;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.IgvExonerado.subscribe(
      response => {
         this.IgvExonerado = response;
      });
  }

  changeClient(value) {
    
    this.igvExonerado.emit(value);
}
}


//select RolContacto

@Component({
  selector: 'app-select-rolContacto',
  template: `<mat-form-field><mat-label>Rol del contacto</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" multiple [(ngModel)]="rolContactoElement">
                  <mat-option *ngFor="let rolContacto of RolContacto" [value]="rolContacto.idGuia" >
                    {{rolContacto.Descripcion}}
                  </mat-option>
              </mat-select>
             </mat-form-field>`         
})

// `<mat-form-field><mat-label>Rol del contacto</mat-label>
// <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="rolContactoElement">
//     <mat-option *ngFor="let rolContacto of RolContacto" [value]="rolContacto.idGuia" >
//      {{rolContacto.Descripcion}}
//     </mat-option>
// </mat-select>
// </mat-form-field>`


export class SelectRolContactoComponent implements OnInit {
  
  @Input() rolContactoElement:string;
  @Output() rolContacto : EventEmitter<string> = new EventEmitter();
  RolContacto:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.RolContacto.subscribe(
      response => {
        this.RolContacto = response;   
      });
  }

  changeClient(value) {
    
    this.rolContacto.emit(value);
}
}

//select Tipo cuenta

@Component({
  selector: 'app-select-tipoCuenta',
  template: `<mat-form-field><mat-label>Cuenta</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoCuentaElement" [required] = "require">
                  <mat-option *ngFor="let tipoCuenta of TipoCuenta" [value]="tipoCuenta.idGuia" >
                   {{tipoCuenta.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoCuentaComponent implements OnInit {

  @Output() tipoCuenta : EventEmitter<string> = new EventEmitter();
  @Input() tipoCuentaElement:string;
  @Input() require : boolean;
  TipoCuenta:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoCuenta.subscribe(
      response => {
        this.TipoCuenta = response;   
      });
  }

  changeClient(value) {
    
    this.tipoCuenta.emit(value);
}
}

//select tipoComprobante

@Component({
  selector: 'app-select-tipoComprobante',
  template: `<mat-form-field><mat-label>Tipo comprobante</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoComprobanteElement" [required] = "require">
                 <div *ngIf="view">
                   <mat-option value=0>
                     Todos
                   </mat-option>  
                </div>  
                  <mat-option *ngFor="let tipoComprobante of TipoComprobante" [value]="tipoComprobante.idGuia" >
                   {{tipoComprobante.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoComprobanteComponent implements OnInit {

  @Output() tipoComprobante : EventEmitter<string> = new EventEmitter();
  @Input() tipoComprobanteElement:string;
  @Input() require : boolean;
  @Input() view : boolean;
  TipoComprobante:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoComprobante.subscribe(
      response => {
        this.TipoComprobante = response;   
      });
  }

  changeClient(value) {
    
    this.tipoComprobante.emit(value);
}
}

//select tipoComprobanteIF

@Component({
  selector: 'app-select-tipoComprobanteIF',
  template: `<mat-form-field><mat-label>Tipo comprobante</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoComprobanteIFElement" [required] = "require">
                 <div *ngIf="view">
                   <mat-option value=0>
                     Todos
                   </mat-option>  
                </div>  
                  <mat-option *ngFor="let tipoComprobanteIF of TipoComprobanteIF" [value]="tipoComprobanteIF.idGuia" >
                   {{tipoComprobanteIF.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoComprobanteIFComponent implements OnInit {

  @Output() tipoComprobanteIF : EventEmitter<string> = new EventEmitter();
  @Input() tipoComprobanteIFElement:string;
  @Input() require : boolean;
  @Input() view : boolean;
  TipoComprobanteIF:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoComprobanteIF.subscribe(
      response => {
        this.TipoComprobanteIF = response;   
      });
  }

  changeClient(value) {
    
    this.tipoComprobanteIF.emit(value);
}
}

//select comprobanteEmitido

@Component({
  selector: 'app-select-comprobanteEmitido',
  template: `<mat-form-field><mat-label>Comprobante emitido</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="comprobanteEmitidoElement" [required] = "require">
                  <mat-option *ngFor="let comprobanteEmitido of ComprobanteEmitido" [value]="comprobanteEmitido.idGuia" >
                   {{comprobanteEmitido.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectComprobanteEmitidoComponent implements OnInit {

  @Output() comprobanteEmitido : EventEmitter<string> = new EventEmitter();
  @Input() comprobanteEmitidoElement:string;
  @Input() require : boolean;
  ComprobanteEmitido:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.ComprobanteEmitido.subscribe(
      response => {
        this.ComprobanteEmitido = response;   
      });
  }

  changeClient(value) {
    
    this.comprobanteEmitido.emit(value);
}
}

//select comprobanteContabilizado

@Component({
  selector: 'app-select-comprobanteContabilizado',
  template: `<mat-form-field><mat-label>Comprobante contabilizado</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="comprobanteContabilizadoElement" [required] = "require">
                  <mat-option *ngFor="let comprobanteContabilizado of ComprobanteContabilizado" [value]="comprobanteContabilizado.idGuia" >
                   {{comprobanteContabilizado.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectComprobanteContabilizadoComponent implements OnInit {

  @Output() comprobanteContabilizado : EventEmitter<string> = new EventEmitter();
  @Input() comprobanteContabilizadoElement:string;
  @Input() require : boolean;
  ComprobanteContabilizado:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.ComprobanteContabilizado.subscribe(
      response => {
        this.ComprobanteContabilizado = response;   
      });
  }

  changeClient(value) {
    
    this.comprobanteContabilizado.emit(value);
}
}

//select condicion

@Component({
  selector: 'app-select-condicion',
  template: `<mat-form-field><mat-label>Condición</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="condicionElement" [required] = "require">
                  <mat-option *ngFor="let condicion of Condicion" [value]="condicion.idGuia" >
                   {{condicion.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectCondicionComponent implements OnInit {

  @Output() condicion : EventEmitter<string> = new EventEmitter();
  @Input() condicionElement:string;
  @Input() require : boolean;
  Condicion:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.Condicion.subscribe(
      response => {
        this.Condicion = response;   
      });
  }

  changeClient(value) {
    
    this.condicion.emit(value);
}
}

//select tipoConformidad

@Component({
  selector: 'app-select-tipoConformidad',
  template: `<mat-form-field><mat-label>Tipo conformidad</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoConformidadElement" [required] = "require">
                  <mat-option *ngFor="let tipoConformidad of TipoConformidad" [value]="tipoConformidad.idGuia" >
                   {{tipoConformidad.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoConformidadComponent implements OnInit {

  @Output() tipoConformidad : EventEmitter<string> = new EventEmitter();
  @Input() tipoConformidadElement:string;
  @Input() require : boolean;
  TipoConformidad:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoConformidad.subscribe(
      response => {
        this.TipoConformidad = response;   
      });
  }

  changeClient(value) {
    
    this.tipoConformidad.emit(value);
}
}



//select tipoEmision

@Component({
  selector: 'app-select-tipoEmision',
  template: `<mat-form-field><mat-label>Tipo emisión</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoEmisionElement" [required] = "require">
                  <div *ngIf="view">
                    <mat-option value=0>
                      Todos
                    </mat-option>  
                  </div>  
                  <mat-option *ngFor="let tipoEmision of TipoEmision" [value]="tipoEmision.idGuia" >
                   {{tipoEmision.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoEmisionComponent implements OnInit {

  @Output() tipoEmision : EventEmitter<string> = new EventEmitter();
  @Input() tipoEmisionElement:string;
  @Input() require : boolean;
  @Input() view : boolean;
  TipoEmision:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoEmision.subscribe(
      response => {
        this.TipoEmision = response;   
      });
  }

  changeClient(value) {
    
    this.tipoEmision.emit(value);
}
}
//select fondoGarantiaBase

@Component({
  selector: 'app-select-fondoGarantiaBase',
  template: `<mat-form-field><mat-label>Fondo garantía base</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="fondoGarantiaBaseElement" [required] = "require" [disabled] = "disable">
                  <mat-option *ngFor="let fondoGarantiaBase of FondoGarantiaBase" [value]="fondoGarantiaBase.idGuia" >
                   {{fondoGarantiaBase.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectFondoGarantiaBaseComponent implements OnInit {

  @Output() fondoGarantiaBase : EventEmitter<string> = new EventEmitter();
  @Input() fondoGarantiaBaseElement:string;
  @Input() require : boolean;
  @Input() disable : boolean;
  FondoGarantiaBase:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.RetencionBase.subscribe(
      response => {
        this.FondoGarantiaBase = response;   
      });
  }

  changeClient(value) {
    
    this.fondoGarantiaBase.emit(value);
}
}

//select detraccionBase

@Component({
  selector: 'app-select-detraccionBase',
  template: `<mat-form-field><mat-label>Detracción base</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="detraccionBaseElement" [required] = "require" [disabled] = "disable">
                  <mat-option *ngFor="let detraccionBase of DetraccionBase" [value]="detraccionBase.idGuia" >
                   {{detraccionBase.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectDetraccionBaseComponent implements OnInit {

  @Output() detraccionBase : EventEmitter<string> = new EventEmitter();
  @Input() detraccionBaseElement:string;
  @Input() require : boolean;
  @Input() disable : boolean;
  DetraccionBase:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.RetencionBase.subscribe(
      response => {
        this.DetraccionBase = response;   
      });
  }

  changeClient(value) {
    
    this.detraccionBase.emit(value);
}
}

//select retencionBase

@Component({
  selector: 'app-select-retencionBase',
  template: `<mat-form-field><mat-label>Retención base</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="retencionBaseElement" [required] = "require" [disabled] = "disable">
                  <mat-option *ngFor="let retencionBase of RetencionBase" [value]="retencionBase.idGuia" >
                   {{retencionBase.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectRetencionBaseComponent implements OnInit {

  @Output() retencionBase : EventEmitter<string> = new EventEmitter();
  @Input() retencionBaseElement:string;
  @Input() require : boolean;
  @Input() disable : boolean;
  RetencionBase:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.RetencionBase.subscribe(
      response => {
        this.RetencionBase = response;   
      });
  }

  changeClient(value) {
    
    this.retencionBase.emit(value);
}
}

//select retencionBase

@Component({
  selector: 'app-select-retencion',
  template: `<mat-form-field><mat-label>Retención Base</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="retencionElement" [required] = "require">
                  <mat-option *ngFor="let retencion of Retencion" [value]="retencion.idGuia" >
                   {{retencion.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectRetencionComponent implements OnInit {

  @Output() retencion : EventEmitter<string> = new EventEmitter();
  @Input() retencionElement:string;
  @Input() require : boolean;
  Retencion:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.Retencion.subscribe(
      response => {
        this.Retencion = response;   
      });
  }

  changeClient(value) {
    
    this.retencion.emit(value);
}
}


//select tipoXls

@Component({
  selector: 'app-select-tipoXls',
  template: `<mat-form-field><mat-label>tipo XLS</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoXlsElement" [required] = "require">
                  <mat-option *ngFor="let tipoXls of TipoXls" [value]="tipoXls.idGuia" >
                   {{tipoXls.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoXlsComponent implements OnInit {

  @Output() tipoXls : EventEmitter<string> = new EventEmitter();
  @Input() tipoXlsElement:string;
  @Input() require : boolean;
  TipoXls:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoXls.subscribe(
      response => {
        this.TipoXls = response;   
      });
  }

  changeClient(value) {
    
    this.tipoXls.emit(value);
}
}

//select tipoPlanilla

@Component({
  selector: 'app-select-tipoPlanilla',
  template: `<mat-form-field><mat-label>Tipo planilla</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoPlanillaElement" [required] = "require">
                  <mat-option *ngFor="let tipoPlanilla of TipoPlanilla" [value]="tipoPlanilla.idGuia" >
                   {{tipoPlanilla.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoPlanillaComponent implements OnInit {

  @Output() tipoPlanilla : EventEmitter<string> = new EventEmitter();
  @Input() tipoPlanillaElement:string;
  @Input() require : boolean;
  TipoPlanilla:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoPlanilla.subscribe(
      response => {
        this.TipoPlanilla = response;   
      });
  }

  changeClient(value) {
    
    this.tipoPlanilla.emit(value);
}
}

//select BancoIF

@Component({
  selector: 'app-select-bancoif',
  template: `<mat-form-field><mat-label>Banco</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="bancoIFElement" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=''>
                    Todos
                  </mat-option>
                </div>
                  <mat-option *ngFor="let bancoIF of TipoBancoIF" [value]="bancoIF.idGuia" >
                   {{bancoIF.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectBancoIFComponent implements OnInit {

  @Output() bancoIF : EventEmitter<string> = new EventEmitter();
  @Input() bancoIFElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  TipoBancoIF:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoBancoIF.subscribe(
      response => {
        this.TipoBancoIF= response;   
      });
  }

  changeClient(value) {
    
    this.bancoIF.emit(value);
}
}

//select Participante

@Component({
  selector: 'app-select-participante',
  template: `<mat-form-field><mat-label>Participante</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="participanteElement" [required] = "require">
                  <mat-option *ngFor="let participante of Participante" [value]="participante.Codigo" >
                   {{participante.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectParticipanteComponent implements OnInit {

  @Output() participante : EventEmitter<string> = new EventEmitter();
  @Input() participanteElement:string;
  @Input() require : boolean;
  Participante:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.Participante.subscribe(
      response => {
        this.Participante = response;   
      });
  }

  changeClient(value) {
    this.participante.emit(value);
}
}

//select RutTitular
@Component({
  selector: 'app-select-RutTitular',
  template: `<mat-form-field><mat-label>Rut Titular</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="rutTitularElement" [required] = "require">
                  <mat-option *ngFor="let rutTitular of RutTitular" [value]="rutTitular.Codigo" >
                   {{rutTitular.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectRutTitularComponent implements OnInit {

  @Output() rutTitular : EventEmitter<string> = new EventEmitter();
  @Input() rutTitularElement:string;
  @Input() require : boolean;
  RutTitular:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.RutTitular.subscribe(
      response => {
        this.RutTitular = response;   
      });
  }

  changeClient(value) {
    this.rutTitular.emit(value);
}
}

//select TipoSolicitud

@Component({
  selector: 'app-select-tipoSolicitud',
  template: `<mat-form-field><mat-label>Tipo Solicitud</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoSolicitudElement" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=0>
                    Todos
                  </mat-option>
                </div>
                  <mat-option *ngFor="let tipoSolicitud of TipoSolicitud" [value]="tipoSolicitud.idGuia" >
                   {{tipoSolicitud.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoSolicitudComponent implements OnInit {

  @Output() tipoSolicitud : EventEmitter<string> = new EventEmitter();
  @Input() tipoSolicitudElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  TipoSolicitud:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoSolicitud.subscribe(
      response => {
        this.TipoSolicitud= response;   
      });
  }

  changeClient(value) {
    
    this.tipoSolicitud.emit(value);
}
}

//select TipoAdjunto

@Component({
  selector: 'app-select-tipoAdjunto',
  template: `<mat-form-field><mat-label>Tipo documento adjunto</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)"  [(ngModel)]="tipoAdjuntoElement" (filtroAdjunto)="filtroAdjunto" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=0>
                    Todos
                  </mat-option>
                </div>
                  <mat-option *ngFor="let tipoAdjunto of TipoAdjunto" [value]="tipoAdjunto.idGuia" >
                   {{tipoAdjunto.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})



export class SelectTipoAdjuntoComponent implements OnInit {

  @Output() tipoAdjunto : EventEmitter<string> = new EventEmitter();
  @Input() tipoAdjuntoElement:string;
  @Input() filtroAdjunto:string;
  @Input() view : boolean;
  @Input() require : boolean;
  TipoAdjunto:any=[];

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoAdjunto.subscribe(
      response => {
        this.TipoAdjunto= response; 
        if (this.filtroAdjunto) {
          this.TipoAdjunto =  this.TipoAdjunto.filter(
            state => state.Codigo == this.filtroAdjunto
          );
        }
      });
  }

  changeClient(value) {
    
    this.tipoAdjunto.emit(value);
}
}

//select TipoOperacion

@Component({
  selector: 'app-select-tipoOperacion',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Tipo Operación</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoOperacionElement" [disabled]="disable" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=0>
                    Todos
                  </mat-option>
                </div>
                  <mat-option *ngFor="let tipoOperacion of TipoOperacion" [value]="tipoOperacion.idGuia" >
                   {{tipoOperacion.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoOperacionComponent implements OnInit {

  @Output() tipoOperacion : EventEmitter<string> = new EventEmitter();
  @Input() tipoOperacionElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  @Input() modelSelect : string;
  @Input() disable : boolean;
  TipoOperacion:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoOperacion.subscribe(
      response => {
        this.TipoOperacion= response;   
      });
  }

  changeClient(value) {
    
    this.tipoOperacion.emit(value);
}
}

//select TipoPagoCPE

@Component({
  selector: 'app-select-tipoPagoCPE',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Tipo Pago</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoPagoCPEElement" [disabled]="disable" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=0>
                    Todos
                  </mat-option>
                </div>
                  <mat-option *ngFor="let tipoPagoCPE of TipoPagoCPE" [value]="tipoPagoCPE.idGuia" >
                   {{tipoPagoCPE.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoPagoCPEComponent implements OnInit {

  @Output() tipoPagoCPE : EventEmitter<string> = new EventEmitter();
  @Input() tipoPagoCPEElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  @Input() modelSelect : string;
  @Input() disable : boolean;
  TipoPagoCPE:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoPagoCPE.subscribe(
      response => {
        this.TipoPagoCPE= response;  
      });
  }

  changeClient(value) {
    
    this.tipoPagoCPE.emit(value);
}
}

//select TipoOperacionNC

@Component({
  selector: 'app-select-tipoOperacionNC',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Tipo Operación</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoOperacionNCElement" [disabled]="disable" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=0>
                    Todos
                  </mat-option>
                </div>
                  <mat-option *ngFor="let tipoOperacionNC of TipoOperacionNC" [value]="tipoOperacionNC.idGuia" >
                   {{tipoOperacionNC.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoOperacionNCComponent implements OnInit {

  @Output() tipoOperacionNC : EventEmitter<string> = new EventEmitter();
  @Input() tipoOperacionNCElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  @Input() modelSelect : string;
  @Input() disable : boolean;
  TipoOperacionNC:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoOperacionNC.subscribe(
      response => {
        this.TipoOperacionNC= response;  
      });
  }

  changeClient(value) {
    
    this.tipoOperacionNC.emit(value);
}
}
//select TipoServicio
@Component({
  selector: 'app-select-tipoServicio',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Tipo Servicio</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoServicioElement" (filtroTipoServicio)="filtroTipoServicio" [disabled]="disable" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=0>
                    Todos
                  </mat-option>
                </div>
                  <mat-option *ngFor="let tipoServicio of TipoServicio" [value]="tipoServicio.idGuia" >
                   {{tipoServicio.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoServicioComponent implements OnInit {

  @Output() tipoServicio : EventEmitter<string> = new EventEmitter();
  @Input() tipoServicioElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  @Input() modelSelect : string;
  @Input() disable : boolean;
  @Input() filtroTipoServicio:string;
  TipoServicio:any;

  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    this.guiasService.TipoServicio.subscribe(
      response => {
        this.TipoServicio= response; 
        if (this.filtroTipoServicio) {
          this.TipoServicio =  this.TipoServicio.filter(
            state => state.Codigo != this.filtroTipoServicio
          );
        } 
      });
  }

  changeClient(value) {
    
    this.tipoServicio.emit(value);
}
}

//select EntidadFinanciera
@Component({
  selector: 'app-select-entidadFinanciera',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>Entidad financiera</mat-label>
              <mat-select (selectionChange)="changeClient($event.value)" [(ngModel)]="entidadFinancieraElement" [disabled]="disable" [required] = "require">
               <div *ngIf="view">
                  <mat-option value=0>
                    Todos
                  </mat-option>
                </div>
                  <mat-option *ngFor="let entidadFinanciera of EntidadFinanciera" [value]="entidadFinanciera.idGuiaBanco" >
                   {{entidadFinanciera.NombreBanco}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectEntidadFinancieraComponent implements OnInit {

  @Output() entidadFinanciera : EventEmitter<any> = new EventEmitter();
  @Output() arrayCuenta : EventEmitter<any> = new EventEmitter();
  @Input() entidadFinancieraElement:string;
  @Input() view : boolean;
  @Input() require : boolean;
  @Input() modelSelect : string;
  @Input() disable : boolean;
  EntidadFinanciera:any;

  entidadF:any=[];
  arrayEntidadFinanciera:any=[];
  cboEntidadF:any={};
  cboEntidadFinanciera:any=[];
  cboMoneda:any=[];
  cboBanco:any=[];
  cboCuenta:any=[];
  idEmpresa_Factor:any;

  constructor(private guiasService:GuiasService) {
    this.idEmpresa_Factor = JSON.parse(sessionStorage.getItem('UserActive')).id_empresa;
   }

  ngOnInit() {
    this.guiasService.EntidadFinanciera.subscribe(
      response => {
        this.entidadF = response; 
        if (this.entidadF.length > 0) {
          this.entidadF = this.entidadF.filter(
            state => state.Codigo == 'FACT_BANCO_GENERAL' && state.id_empresa == this.idEmpresa_Factor
          );
          for(let item of this.entidadF){
            this.cboEntidadF={};
            let array = item.Descripcion;
            this.arrayEntidadFinanciera = array.split("|");
            this.cboEntidadF.NombreBanco = this.arrayEntidadFinanciera[0];
            this.cboEntidadF.Nombre_Firmante = this.arrayEntidadFinanciera[1];
            this.cboEntidadF.TipoEntidad = this.arrayEntidadFinanciera[2];
            this.cboEntidadF.DescripcioEntidad = this.arrayEntidadFinanciera[3];
            this.cboEntidadF.MonedaBanco = this.arrayEntidadFinanciera[4];
            this.cboEntidadF.NumeroCuenta = this.arrayEntidadFinanciera[5];
            this.cboEntidadF.NumeroCuentaInt = this.arrayEntidadFinanciera[6];
            this.cboEntidadF.idGuiaBanco = this.arrayEntidadFinanciera[7];
            this.cboEntidadF.idGuiaMoneda = this.arrayEntidadFinanciera[8];
  
            this.cboEntidadFinanciera.push(this.cboEntidadF);
        }

        var hash = {};
        this.EntidadFinanciera = this.cboEntidadFinanciera.filter(function(current) {
        var exists = !hash[current.NombreBanco];
        hash[current.NombreBanco] = true;
        return exists;
      });
 
        }
        

      });  


  }

  changeClient(value) {
    this.arrayCuenta.emit(this.cboEntidadFinanciera);
    this.entidadFinanciera.emit(value);
}
}

//Select TipoFacturacion
@Component({
  selector: 'app-select-tipoFacturacion',
  template: `<mat-form-field [appearance]="modelSelect"><mat-label>{{titulo}} </mat-label>
              <mat-select  (selectionChange)="changeClient($event.value)" [(ngModel)]="tipoFacturacionElement" [disabled]="disable" required>
                  <mat-option *ngFor="let tipoFacturacion of tipoFacturacion" [value]="tipoFacturacion.TablaValor" >
                   {{tipoFacturacion.Descripcion}}
                  </mat-option>
              </mat-select>
              </mat-form-field>`
})

export class SelectTipoFacturacion implements OnInit {

  @Input() tipoFacturacionElement:string;
  @Input() disable:boolean ;
  @Input() modelSelect : string;
  @Input() tituloSN : string;
  @Output() TipoFacturacion : EventEmitter<string> = new EventEmitter();
  tipoFacturacion:any;
  enable:boolean;
  titulo:string = "";
  constructor(private guiasService:GuiasService) {
   }

  ngOnInit() {
    if (this.tituloSN == "1") {
      console.log('this.tituloSN',this.tituloSN);
      this.titulo = "Tipo Facturación"
    }

    this.guiasService.TipoFacturacion.subscribe(
      response => {
         this.tipoFacturacion = response;
      });
  }

  changeClient(value) {  
    this.TipoFacturacion.emit(value);
}
}

//select RepresentanteIF
@Component({
  selector: 'app-multiselect-representanteIF',
  template: ` <form #f='ngForm'>
              <angular2-multiselect [data]="CboRepresentanteIFF" [(ngModel)]="selectedItems" [settings]="dropdownSettings" (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)" name='selectedItems'
                  ngModel>
              </angular2-multiselect>
              <p style="color:red" *ngIf="!requiredField">
                  Seleccione Firmante o representante!
              </p>
            </form>`
})

export class MultiSelectRepresentanteIFComponent implements OnInit {
 Id_Tipo_DNI=environment.ID_TIPO_DNI;
  @Output() selectedItem : EventEmitter<any> = new EventEmitter();

  dropdownSettings = {};
  requiredField: boolean = true;
  inputDefault : any = [];
  searchField:string ="";
  dropdownList = [];
  selectedItems = [];
 
  RepresentanteIF:any=[];
  ArrayRepresentanteIF:any=[];
  CboRepresentanteIF:any={};
  CboRepresentanteIFF:any=[];

  dataSelect:any=[];
  idEmpresa_Factor:any;

  constructor(private guiasService:GuiasService) {

    this.idEmpresa_Factor = JSON.parse(sessionStorage.getItem('UserActive')).id_empresa;

    this.guiasService.RepresentanteIF.subscribe(
      response => { 
        this.RepresentanteIF = response; 
        this.RepresentanteIF = this.RepresentanteIF.filter(
          state => state.id_empresa == this.idEmpresa_Factor
        );
        for(let item of this.RepresentanteIF){
          this.CboRepresentanteIF={};
          let array = item.Descripcion;
          this.ArrayRepresentanteIF = array.split("|");
          this.CboRepresentanteIF.idRepresentanteIF = this.ArrayRepresentanteIF[0];
          this.CboRepresentanteIF.Nombre_Firmante = this.ArrayRepresentanteIF[1];
          this.CboRepresentanteIF.Num_Doc_Identificacion = this.ArrayRepresentanteIF[2];
          this.CboRepresentanteIF.Cargo = this.ArrayRepresentanteIF[3];
          this.CboRepresentanteIF.Raz_Social = this.ArrayRepresentanteIF[4];
          this.CboRepresentanteIF.RUC = this.ArrayRepresentanteIF[5];
          this.CboRepresentanteIF.Tipo_Firmante = this.ArrayRepresentanteIF[6];
          this.CboRepresentanteIF.Direccion = this.ArrayRepresentanteIF[7];
          this.CboRepresentanteIF.Distrito = this.ArrayRepresentanteIF[8];
          this.CboRepresentanteIF.Provincia = this.ArrayRepresentanteIF[9];

          this.CboRepresentanteIF.Correo = " ";
          this.CboRepresentanteIF.Telefono = " ";
          this.CboRepresentanteIF.Tipo_Doc_Identificacion = this.Id_Tipo_DNI;

          this.CboRepresentanteIFF.push(this.CboRepresentanteIF);
      }
      }); 
      
      this.inputDefault = this.CboRepresentanteIFF.filter(
        state => state.Tipo_Firmante == 1
      );  
      
      this.filterRecords(this.searchField); 
   }

  ngOnInit() {

    this.selectedItem.emit(this.inputDefault);

      this.dropdownSettings = {
        singleSelection: false,
        text: "Seleccione firmante",
        selectAllText: 'Seleccionar todo',
        unSelectAllText: 'Desmarcar todo',
        enableSearchFilter: false,
        labelKey: 'Nombre_Firmante',
        primaryKey: 'idRepresentanteIF',
        classes: "myclass custom-class",
        badgeShowLimit: 3,
        limitSelection:3
      };

  }

  


  onItemSelect(item: any) {
    this.setStatus();
  }

  setStatus() {
    (this.selectedItems.length > 0) ? this.requiredField = true : this.requiredField = false;
    this.selectedItem.emit(this.selectedItems);
  }

  OnItemDeSelect(item: any) {
    this.setStatus();
  }

  onSelectAll(items: any) {
    this.setStatus();
  }

  onDeSelectAll(items: any) {
    this.selectedItems = [];
    this.setStatus();
  }

  filterRecords(textToSearch: string) {
    let tempArray = [];
     this.inputDefault.forEach((item, index) => {
      if(item.Nombre_Firmante.indexOf(textToSearch.toLowerCase()) > -1) {
        tempArray.push(item);
      }
    })

    if(tempArray.length > 0){
      this.selectedItems = tempArray;
    }
  }
}

//select RepresentanteCliente
@Component({
  selector: 'app-multiselect-representanteCLI',
  template: ` <form #f='ngForm'>
              <angular2-multiselect [data]="dataCombo" [(ngModel)]="selectedItems" [settings]="dropdownSettings" (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)" (onDeSelectAll)="onDeSelectAll($event)" name='selectedItems'
                  ngModel>
              </angular2-multiselect>
              <p style="color:red" *ngIf="!requiredField">
                  Seleccione Firmante o representante!
              </p>
            </form>`
})

export class MultiSelectRepresentanteCLIComponent implements OnInit {

  @Output() selectedItem : EventEmitter<any> = new EventEmitter();
  dataCombo:any=[];

  dropdownSettings = {};
  requiredField: boolean = true;
  inputDefault : any = [];
  searchField:string ="";
  dropdownList = [];
  selectedItems = [];
 
  RepresentanteCLI:any=[];
  ArrayRepresentanteIF:any=[];
  CboRepresentanteIF:any={};
  CboRepresentanteCLII:any=[];

  dataSelect:any=[];

  constructor(private guiasService:GuiasService) {
         
   }

  ngOnInit() {
    
    this.guiasService.RepresentanteCLI.subscribe(
      response => {
        this.dataCombo = response;  
        if (this.dataCombo.length > 0) {
          this.inputDefault=[];
          this.dataCombo.forEach((item, index) => {
            if(index < 3) {
              this.inputDefault.push(item);
            }
          })
          this.selectedItem.emit(this.inputDefault);
          this.filterRecords(this.searchField);
           
          this.dropdownSettings = {
            singleSelection: false,
            text: "Seleccione firmante del adquirente",
            selectAllText: 'Seleccionar todo',
            unSelectAllText: 'Desmarcar todo',
            enableSearchFilter: false,
            labelKey: 'NombreCorreo',
            primaryKey: 'idContacto',
            classes: "myclass custom-class",
            badgeShowLimit: 3,
            limitSelection: 3
          };
        } 
      });
  }

  onItemSelect(item: any) {
    this.setStatus();
  }

  setStatus() {
    (this.selectedItems.length > 0) ? this.requiredField = true : this.requiredField = false;
    this.selectedItem.emit(this.selectedItems);
  }

  OnItemDeSelect(item: any) {
    this.setStatus();
  }

  onSelectAll(items: any) {
    this.setStatus();
  }

  onDeSelectAll(items: any) {
    this.selectedItems = [];
    this.setStatus();
  }

  filterRecords(textToSearch: string) {
    let tempArray = [];
     this.inputDefault.forEach((item, index) => {
      if(item.Correo.indexOf(textToSearch.toLowerCase()) > -1) {
        tempArray.push(item);
      }
    })
    if(tempArray.length > 0){
      this.selectedItems = tempArray;
    }
  }


 

}